import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { LoadingPlaceHolder } from '../LoadingPlaceholder';
import { useIsPreSeatsPortal } from '../data-cache/dataCacheHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceWrapper = ({
  columnConfig
}) => {
  var _columnConfig$price;
  const isPreSeatsPortal = useIsPreSeatsPortal();
  return /*#__PURE__*/_jsx(View, {
    blockSize: "30px",
    marginBlockEnd: "300",
    children: columnConfig.productApiName.includes('free') || ((_columnConfig$price = columnConfig.price) === null || _columnConfig$price === void 0 ? void 0 : _columnConfig$price.price) === null ? null : columnConfig.price === undefined ? /*#__PURE__*/_jsx(LoadingPlaceHolder, {
      width: 220,
      height: 30
    }) : /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: columnConfig.price.price,
        showPricePerMonthPerSeat: columnConfig.isSeatBasedProduct && !isPreSeatsPortal,
        seleniumId: `feature-table-price-${columnConfig.productApiName}`,
        currencyCode: columnConfig.price.currencyCode
      })
    })
  });
};